<div class="mask-layer report" *ngIf="visible">
    <div class="mask-bg">
        <div class="mask-bgBox">
            <div class="mask-top d-flex justify-content-between w-100 py-2 px-2 fs-5">
                <div class="align-self-center">
                    <div class="i18n" data-tag="report">{{ 'contents.report.report' | translate }}</div>
                </div>
                <div class="align-self-center">
                    <button class="report-close" (click)="onClose()">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
            </div>

            <div class="mask-main">
                <div class="row">
                    <div class="col-md-12 col-lg-8 col-xl-8">

                        <select id="report-type" [(ngModel)]="provider">
                            <option value="" class="i18n" data-tag="allGame">
                                {{ 'contents.report.games' | translate }}
                            </option>
                            <option value="9" class="i18n" data-tag="game.id.9">
                                {{ 'contents.report.provider.bgc' | translate }}
                            </option>
                            <option value="15" class="i18n" data-tag="game.id.15">
                                {{ 'contents.report.provider.ctc' | translate }}
                            </option>
                            <option value="17" class="i18n" data-tag="game.id.17">
                                {{ 'contents.report.provider.wic' | translate }}
                            </option>
                            <option value="18" class="i18n" data-tag="game.id.18">
                                {{ 'contents.report.provider.gmpgs' | translate }}
                            </option>
                            <option value="19" class="i18n" data-tag="game.id.19">
                                {{ 'contents.report.provider.gmpps' | translate }}
                            </option>
                            <option value="23" class="i18n" data-tag="game.id.23">
                                {{ 'contents.report.provider.dgc' | translate }}
                            </option>
                        </select>

                        <select id="report-state" [(ngModel)]="payrollStatus">
                            <option value="" class="i18n" data-tag="isRevocation">{{ 'contents.report.payroll_status' |
                                translate }}</option>
                            <option value="Unsettled" class="i18n" data-tag="isRevocation.0">{{
                                'contents.report.unsettlement' |
                                translate }}</option>
                            <option value="Settled" class="i18n" data-tag="isRevocation.1">{{ 'contents.report.settled'
                                |
                                translate }}</option>
                            <option value="Revoked" class="i18n" data-tag="isRevocation.2">{{ 'contents.report.revoked'
                                |
                                translate }}</option>
                        </select>

                        <select class="beginTime" [(ngModel)]="startDate">
                            <ng-container *ngIf="dateList">
                                <ng-container *ngFor="let date of dateList">
                                    <option value="{{date}}">{{ date }}</option>
                                </ng-container>
                            </ng-container>
                        </select>

                        <select class="endTime" [(ngModel)]="endDate">
                            <ng-container *ngIf="dateList">
                                <ng-container *ngFor="let date of dateList">
                                    <option value="{{date}}">{{ date }}</option>
                                </ng-container>
                            </ng-container>
                        </select>
                    </div>
                    <div class="col-md-12 col-lg-4 col-xl-4">
                        <div class="d-flex justify-content-end">
                            <button class="i18n search-btn" data-tag="search" (click)="onSearch()">{{
                                'contents.report.search' | translate }}</button>

                            <ul class="flex time-menu">
                                <li class="i18n" [class.active]="activeTab === 'tDay'" data-tag="tDay"
                                    (click)="setToday()">{{ 'contents.report.tday' |
                                    translate }}</li>
                                <li class="i18n" [class.active]="activeTab === 'yDay'" data-tag="yDay"
                                    (click)="setYesterday()">{{ 'contents.report.yday' |
                                    translate }}</li>
                                <li class="i18n" [class.active]="activeTab === 'tWeek'" data-tag="tWeek"
                                    (click)="setLast7Days()">{{ 'contents.report.7day' |
                                    translate }}</li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
            <div class="responsive-table">

                <table>
                    <thead>
                        <tr>
                            <th class="i18n" data-tag="number">{{ 'contents.report.number' | translate }}</th>
                            <th class="i18n" data-tag="game">{{ 'contents.report.game' | translate }}</th>
                            <th class="i18n" data-tag="gameBetAmount">{{ 'contents.report.bet_amount' | translate }}
                            </th>
                            <th class="i18n" data-tag="validBets">{{ 'contents.report.valid_bets' | translate }}</th>
                            <th class="i18n" data-tag="winLoss">{{ 'contents.report.winloss' | translate }}</th>
                            <th class="i18n" data-tag="isRevocation">{{ 'contents.report.payroll_status' | translate }}s
                            </th>
                            <th class="i18n" data-tag="betTime">{{ 'contents.report.bet_time' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody class="report-info">
                        <ng-container *ngIf="this.report && this.report.Records">
                            <ng-container *ngFor="let record of this.report.Records; let i = index">
                                <tr>
                                    <th>{{ i + 1 }}</th>
                                    <th>{{ record.ProviderName }} {{ record.GameName }}</th>
                                    <th>{{ record.BetAmt }}</th>
                                    <th>{{ record.ValidBet }}</th>
                                    <th [style.color]="record.WlAmt >= 0 ? 'green' : 'red'">{{ record.WlAmt.toFixed(2)
                                        }}
                                    </th>
                                    <th>{{ record.TicketStatus }}</th>
                                    <th>{{ record.SettlementTime | date: 'yyyy-MM-dd HH:mm:ss' }}</th>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th class="i18n" data-tag="total">{{ 'contents.report.total' | translate }}</th>
                            <th class="total-items">{{ this.totalCurrentPageItems }}</th>
                            <th class="points-bet">{{ this.totalBetAmt.toFixed(2) }}</th>
                            <th class="available-bet ">{{ this.totalValidBet.toFixed(2) }}</th>
                            <th class="total-win">{{ this.totalWlAmt.toFixed(2) }}</th>
                            <th colspan="2"></th>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <div class="flex simple-pagination">
                <div class="prev-btn i18n" data-tag="pre" (click)="filp(-1)">{{ 'contents.report.pre' | translate }}
                </div>
                <span class="i18n" data-tag="total">{{ 'contents.report.total' | translate }}</span>：
                <span class="total-pages">{{ (report?.Pagination) ? report?.Pagination?.TotalPages : 0 }}</span>
                <input #pageInput class="page-now" type="number" [value]="report?.Pagination?.PageNumber || 1">
                <input class="paging" type="button" value="{{ 'contents.report.go' | translate }}"
                    (click)="skip(pageInput.value)">
                <div class="next-btn i18n" data-tag="next" (click)="filp(1)">{{ 'contents.report.next' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>